(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-brand-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseCarousel = (section) => {
      const viewport = section.querySelector('[data-carousel-viewport]');
      const track = viewport?.querySelector('.custom-brand-carousel__track');
      const firstGroup = viewport?.querySelector('.custom-brand-carousel__group:not(.custom-brand-carousel__group--duplicate)');

      if (!viewport || !track || !firstGroup || viewport.dataset.initialised === 'true') return;

      viewport.dataset.initialised = 'true';

      const direction = viewport.dataset.direction === 'right' ? 'right' : 'left';
      const duration = Math.max(Number(viewport.dataset.duration) || 60, 8);
      const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let reduceMotion = motionPreference.matches;

      let paused = false;
      let interacting = false;
      let lastTimestamp = 0;
      let resumeTimer;
      let animationFrame;

      let loopWidth = 0;
      let position = 0;
      const wrap = (value) => ((value % loopWidth) + loopWidth) % loopWidth;
      const setPosition = (value) => {
        position = !reduceMotion && loopWidth > 0 ? wrap(value) : value;
        viewport.scrollLeft = position;
      };
      const measure = () => {
        loopWidth = firstGroup.getBoundingClientRect().width;
        if (!loopWidth || !viewport.clientWidth) return;
        // Include a trailing gap in each repeat and fill even very wide viewports.
        const groupCount = reduceMotion ? 1 : Math.ceil(viewport.clientWidth / loopWidth) + 2;
        while (track.children.length > groupCount) track.lastElementChild.remove();
        while (track.children.length < groupCount) {
          const copy = firstGroup.cloneNode(true);
          copy.classList.add('custom-brand-carousel__group--duplicate');
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          track.append(copy);
        }
        setPosition(position);
      };
      const normalisePosition = () => {
        // Native keyboard and wheel scrolling must also keep the animation in sync.
        if (Math.abs(viewport.scrollLeft - position) > 1) setPosition(viewport.scrollLeft);
      };

      const pauseTemporarily = () => {
        interacting = true;
        window.clearTimeout(resumeTimer);
      };

      const resumeAfterInteraction = () => {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => {
          interacting = false;
          lastTimestamp = performance.now();
        }, 900);
      };

      const animate = (timestamp) => {
        if (!lastTimestamp) lastTimestamp = timestamp;

        const elapsed = Math.min(timestamp - lastTimestamp, 100);
        lastTimestamp = timestamp;

        if (!paused && !interacting && !reduceMotion) {
          if (loopWidth > 0) {
            const movement = loopWidth * elapsed / (duration * 1000);
            setPosition(position + (direction === 'right' ? -movement : movement));
          }
        }

        animationFrame = window.requestAnimationFrame(animate);
      };

      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(viewport);
      resizeObserver.observe(firstGroup);
      const onMotionChange = () => {
        reduceMotion = motionPreference.matches;
        measure();
      };
      motionPreference.addEventListener('change', onMotionChange);
      measure();

      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartScrollLeft = 0;
      let touchIsHorizontal = false;
      let suppressClick = false;

      viewport.addEventListener('touchstart', (event) => {
        if (!event.touches.length) return;

        pauseTemporarily();
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchStartScrollLeft = viewport.scrollLeft;
        touchIsHorizontal = false;
        suppressClick = false;
      }, { passive: true });

      viewport.addEventListener('touchmove', (event) => {
        if (!event.touches.length) return;

        const deltaX = event.touches[0].clientX - touchStartX;
        const deltaY = event.touches[0].clientY - touchStartY;

        if (!touchIsHorizontal && Math.abs(deltaX) > 6) {
          touchIsHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        }

        if (!touchIsHorizontal) return;

        event.preventDefault();
        suppressClick ||= Math.abs(deltaX) > 8;
        setPosition(touchStartScrollLeft - deltaX);
      }, { passive: false });

      viewport.addEventListener('touchend', () => {
        resumeAfterInteraction();
      }, { passive: true });

      viewport.addEventListener('touchcancel', () => {
        resumeAfterInteraction();
      }, { passive: true });

      viewport.addEventListener('pointerdown', (event) => {
        // Mouse clicks follow the link normally; only touch gestures move the logos.
        if (event.pointerType === 'mouse') suppressClick = false;
      });

      viewport.addEventListener('click', (event) => {
        if (!suppressClick || event.detail === 0) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);

      viewport.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      viewport.addEventListener('wheel', () => {
        pauseTemporarily();
        resumeAfterInteraction();
      }, { passive: true });

      viewport.addEventListener('mouseenter', () => {
        paused = true;
      });

      viewport.addEventListener('mouseleave', () => {
        paused = viewport.matches(':hover') || viewport.contains(document.activeElement);
        resumeAfterInteraction();
      });

      viewport.addEventListener('focusin', () => {
        paused = true;
      });

      viewport.addEventListener('focusout', (event) => {
        paused = viewport.matches(':hover') || viewport.contains(event.relatedTarget);
        resumeAfterInteraction();
      });

      viewport.addEventListener('scroll', normalisePosition, { passive: true });

      animationFrame = window.requestAnimationFrame(animate);

      const sectionWrapper = section.closest('.shopify-section') || section;
      sectionWrapper.addEventListener('shopify:section:unload', () => {
        resizeObserver.disconnect();
        motionPreference.removeEventListener('change', onMotionChange);
        window.cancelAnimationFrame(animationFrame);
        window.clearTimeout(resumeTimer);
      }, { once: true });
    };

    const initialiseAll = (root = document) => {
      root.querySelectorAll('[data-brand-carousel]').forEach(initialiseCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
